import { localDateToYmd } from '@nudool/design-system';

/** A picked local day as its `YYYY-MM-DD` search param. */
export function dateToParam(date: Date | undefined): string | undefined {
  return date ? localDateToYmd(date) : undefined;
}
